export var CoordinateSystem;

(function (CoordinateSystem) {
  CoordinateSystem[CoordinateSystem["LNGLAT"] = 1] = "LNGLAT";
  CoordinateSystem[CoordinateSystem["LNGLAT_OFFSET"] = 2] = "LNGLAT_OFFSET";
  CoordinateSystem[CoordinateSystem["VECTOR_TILE"] = 3] = "VECTOR_TILE";
  CoordinateSystem[CoordinateSystem["IDENTITY"] = 4] = "IDENTITY";
  CoordinateSystem[CoordinateSystem["P20"] = 5] = "P20";
  CoordinateSystem[CoordinateSystem["P20_OFFSET"] = 6] = "P20_OFFSET";
  CoordinateSystem[CoordinateSystem["METER_OFFSET"] = 7] = "METER_OFFSET";
  CoordinateSystem[CoordinateSystem["P20_2"] = 8] = "P20_2";
})(CoordinateSystem || (CoordinateSystem = {}));

export var CoordinateUniform = {
  CoordinateSystem: 'u_CoordinateSystem',
  ViewportCenter: 'u_ViewportCenter',
  ViewportCenterProjection: 'u_ViewportCenterProjection',
  PixelsPerDegree: 'u_PixelsPerDegree',
  PixelsPerDegree2: 'u_PixelsPerDegree2',
  PixelsPerMeter: 'u_PixelsPerMeter',
  Mvp: 'u_Mvp'
};
//# sourceMappingURL=ICoordinateSystemService.js.map